export const SERVICES = [
  {
    slug: "render-insulation",
    name: "External Render & Insulation",
    short: "Energy-efficient external wall insulation and modern render finishes for homes and commercial buildings.",
    image: "https://customer-assets.emergentagent.com/job_cresttor-launch/artifacts/upbg8q1t_Cresttor%20Construction%20Render%20Project.JPG",
    bullets: [
      "Silicone, acrylic and mineral render systems",
      "External Wall Insulation (EWI) — 90mm to 200mm",
      "PAS 2035-aligned retrofit coordination",
      "Funded scheme experience (GBIS/ECO awareness)",
      "Solid-wall, timber-frame and SIP compatible",
    ],
    faqs: [
      { q: "Will external insulation reduce my heating bills?", a: "Yes — well-fitted EWI typically cuts heat loss through walls by 40–60%, improving EPC ratings and significantly reducing annual heating costs." },
      { q: "How long does a typical render job take?", a: "A 3-bed semi-detached property usually takes 2–4 weeks depending on weather, scaffolding access and the chosen render system." },
      { q: "Do you offer a guarantee?", a: "All our render and insulation work is backed by a written workmanship guarantee, alongside the manufacturer’s system warranty." },
    ],
  },
  {
    slug: "domestic-extensions",
    name: "Domestic Builds & Extensions",
    short: "Single & double-storey extensions, loft conversions, full renovations and new-build homes.",
    image: "https://customer-assets.emergentagent.com/job_cresttor-launch/artifacts/sstjcy3y_Cresttor%20Construction%20Steelwork%20Extension%20Allerton.jpeg",
    bullets: [
      "Side, rear and wrap-around extensions",
      "Loft conversions and dormer builds",
      "Full house renovations and refurbishments",
      "Structural openings, steels and groundworks",
      "Building regulations & planning liaison",
    ],
    faqs: [
      { q: "Do I need planning permission?", a: "Many extensions fall under permitted development, but we’ll confirm during your site survey and handle the application end-to-end if required." },
      { q: "Can you manage the entire project?", a: "Yes — from architect drawings and structural calculations to first-fix, second-fix and final decoration. One trusted point of contact throughout." },
      { q: "How accurate are your quotes?", a: "Our written quotes are itemised and fixed-price wherever possible — no surprise extras for the client." },
    ],
  },
  {
    slug: "commercial",
    name: "Commercial Construction",
    short: "Fit-outs, refurbishments, retrofit and new-build commercial projects across the North West.",
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?crop=entropy&cs=srgb&fm=jpg&w=1200&q=80",
    bullets: [
      "Office, retail and hospitality fit-outs",
      "Industrial unit refurbishment & cladding",
      "Multi-occupancy retrofit (PAS 2035)",
      "Public sector and housing association works",
      "Scheduled programmes with minimal downtime",
    ],
    faqs: [
      { q: "Do you work out of hours to minimise disruption?", a: "Yes — for retail and hospitality clients we routinely run evening and overnight shifts so trading isn’t affected." },
      { q: "Are you fully insured for commercial sites?", a: "We carry £5m public liability, employers’ liability and full contract works insurance. Documentation provided on request." },
      { q: "Can you handle CDM responsibilities?", a: "Yes — we operate as Principal Contractor under CDM 2015 with appointed designers and full RAMS documentation." },
    ],
  },
  {
    slug: "landscaping",
    name: "Landscaping & Hard-Surfacing",
    short: "Driveways, patios, garden walls, decking, fencing and complete outdoor transformations.",
    image: "https://images.unsplash.com/photo-1761637823730-fab1f300084d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBnYXJkZW4lMjBsYW5kc2NhcGluZ3xlbnwwfHx8fDE3NzgxNjM4MTV8MA&ixlib=rb-4.1.0&q=85",
    bullets: [
      "Block-paved & resin-bound driveways",
      "Indian sandstone, porcelain & natural patios",
      "Garden walls, retaining walls and steps",
      "Composite decking and fencing",
      "Drainage, levels and lighting integration",
    ],
    faqs: [
      { q: "Do you provide design as well as build?", a: "Yes — we offer concept sketches, planting plans and 3D visuals for larger garden projects, included in the quote." },
      { q: "How long does a typical driveway take?", a: "A standard 60 m² block-paved driveway is usually complete within 7–10 working days, weather permitting." },
      { q: "Do you work with permeable/SuDS-compliant materials?", a: "Absolutely — we’ll specify permeable paving or resin-bound systems where planning or run-off rules require it." },
    ],
  },
];

export const findService = (slug) => SERVICES.find((s) => s.slug === slug);
